import CardSelection from 'features/cardManagement/screens/CardSelection/CardSelectionScreen';
import React from 'react';

export default function CardSelectionPage() {
  return <CardSelection />;
}
